import { action } from "satcheljs";
import type { ClientItemId } from "owa-client-ids";

export interface OnMailServiceForwardMessageActionMessage {
    clientItemId: ClientItemId;
}
const onMailServiceForwardMessage: (clientItemId: ClientItemId) => OnMailServiceForwardMessageActionMessage = action("onMailServiceForwardMessage", (clientItemId: ClientItemId): OnMailServiceForwardMessageActionMessage => ({
    clientItemId,
}));

export default onMailServiceForwardMessage;
